/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Error_UnavailableInputs */



/**
* | output |
* | --- |
* | "The AI Assistant is temporarily unavailable. Please try again in a moment." |
*
* @param {Assistant_Error_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_error_unavailable = /** @type {((inputs?: Assistant_Error_UnavailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Error_UnavailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'assistant IA est temporairement indisponible. Veuillez réessayer dans quelques instants.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der KI-Assistent ist vorübergehend nicht verfügbar. Bitte versuchen Sie es in Kürze erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'assistente AI non è temporaneamente disponibile. Riprova tra un attimo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Искусственный интеллект-помощник временно недоступен. Пожалуйста, попробуйте еще раз через некоторое время.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El asistente de IA no está disponible temporalmente. Inténtelo de nuevo en un momento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI助手暂时无法使用，请稍后再试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタントは現在一時的にご利用いただけません。しばらくしてからもう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई असिस्टेंट फिलहाल अनुपलब्ध है। कृपया कुछ देर बाद पुनः प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O Assistente de IA está temporariamente indisponível. Tente novamente em instantes.")
	return /** @type {LocalizedString} */ ("The AI Assistant is temporarily unavailable. Please try again in a moment.")
});